import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedinIn, FaArrowUp, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaShip, FaMobileAlt } from 'react-icons/fa'; 

const Footer = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowScroll(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const googleMapsUrl = "https://www.google.com/maps?ll=41.046173,29.007276&z=16&t=m&hl=tr&gl=TR&mapclient=embed&q=Barbaros+Blv.+No:49+Cihann%C3%BCma+34353+Be%C5%9Fikta%C5%9F/%C4%B0stanbul";

  

  return (
    <footer className="relative bg-[#0f172a] text-[#f1f5f9] pt-24 pb-12 overflow-hidden border-t border-[#c4a47c]/20 font-sans">
      

      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-500/5 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#c4a47c]/5 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="container mx-auto px-6 sm:px-8 lg:px-16 relative z-10">
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 mb-20">
          

          <div className="lg:col-span-4 space-y-8 text-left">
            <div className="flex items-center space-x-3 group">
              <div className="p-3 bg-gradient-to-br from-[#c4a47c] to-[#a3865f] rounded-2xl shadow-[0_0_20px_rgba(196,164,124,0.2)]">
                <FaShip className="text-[#0f172a] text-2xl" />
              </div>
              <h3 className="text-2xl font-black tracking-tighter text-white uppercase italic">
                Armar <span className="text-[#c4a47c]">Shipping</span>
              </h3>
            </div>
            <p className="text-[15px] sm:text-[16px] leading-relaxed text-slate-300 font-medium max-w-md">
              ARMAR SHIPPING COMPANY (ARMARSHIP), has been established in Istanbul on 11.11.2011 with the aim of providing a comprehensive agency services for valuable Charterers & Ship Owners & Operators in a proper manner, reliable and professional way at TURKISH STRAITS and PORTS plus at Turkish main Shipyards in Tuzla and Yalova areas.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://tr.linkedin.com/in/laki-pribilovic-84623965" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 text-[#c4a47c] hover:bg-[#c4a47c] hover:text-[#0f172a] transition-all duration-500"
              >
                <FaLinkedinIn size={18} />
              </a>
            </div>
          </div>

  

<div className="lg:col-span-3 space-y-8 text-left">
  <h4 className="text-[#c4a47c] text-sm font-black uppercase tracking-[0.4em]">Navigation</h4>
  <nav className="flex flex-col space-y-4">
    {[
      { name: 'Home', path: '/' },
      { name: 'About Us', path: '/about' },
      { name: 'Services', path: '/services' },
      { name: 'Useful Information', path: '/useful-information' },
      { name: 'Contact', path: '/contact' },
    ].map((link) => (
      <Link 
        key={link.name}
        to={link.path}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="text-[17px] font-bold text-slate-200 hover:text-[#c4a47c] transition-all flex items-center group"
      >
        <span className="w-0 group-hover:w-5 h-[2px] bg-[#c4a47c] transition-all duration-300 mr-0 group-hover:mr-3"></span>
        {link.name}
      </Link>
    ))}
  </nav>
</div>

      
          <div className="lg:col-span-5 space-y-8">
            <h4 className="text-[#c4a47c] text-sm font-black uppercase tracking-[0.4em] text-left"> Contact</h4>
            <div className="grid gap-3">
              
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
                <a href="tel:+902122588002" className="p-4 bg-white/5 border border-white/10 rounded-[1.2rem] hover:bg-white/10 transition-all group flex items-center space-x-3">
                  <div className="p-2.5 bg-[#c4a47c]/10 rounded-xl flex-shrink-0 group-hover:bg-[#c4a47c] transition-colors duration-300">
                    <FaPhoneAlt className="text-[#c4a47c] group-hover:text-[#0f172a] text-sm" />
                  </div>
                  <div className="min-w-0">
                    <span className="block text-[#c4a47c] text-[9px] font-black uppercase tracking-widest">Office</span>
                    <span className="text-white font-bold text-[15px] tracking-tight">+90 212 258 80 02</span>
                  </div>
                </a>
                <a href="tel:+905454005050" className="p-4 bg-white/5 border border-white/10 rounded-[1.2rem] hover:bg-white/10 transition-all group flex items-center space-x-3">
                  <div className="p-2.5 bg-[#c4a47c]/10 rounded-xl flex-shrink-0 group-hover:bg-[#c4a47c] transition-colors duration-300">
                    <FaMobileAlt className="text-[#c4a47c] group-hover:text-[#0f172a] text-sm" />
                  </div>
                  <div className="min-w-0">
                    <span className="block text-[#c4a47c] text-[9px] font-black uppercase tracking-widest">Cell</span>
                    <span className="text-white font-bold text-[15px] tracking-tight">+90 545 400 50 50</span>
                  </div>
                </a>
              </div>

              <a href="mailto:armar@armarship.com" className="p-4 bg-white/5 border border-white/10 rounded-[1.2rem] hover:bg-white/10 transition-all group flex items-center space-x-3">
                <div className="p-2.5 bg-[#c4a47c]/10 rounded-xl flex-shrink-0 group-hover:bg-[#c4a47c] transition-colors duration-300">
                  <FaEnvelope className="text-[#c4a47c] group-hover:text-[#0f172a] text-sm" />
                </div>
                <div className="min-w-0">
                  <span className="block text-[#c4a47c] text-[9px] font-black uppercase tracking-widest">Email</span>
                  <span className="text-white font-bold text-[15px] tracking-tight">armar@armarship.com</span>
                </div>
              </a>

              <div className="p-4 bg-white/5 border border-white/10 rounded-[1.5rem] hover:bg-white/10 transition-all group flex items-center space-x-4">
                <div className="p-3 bg-[#c4a47c]/10 rounded-xl flex-shrink-0 group-hover:bg-[#c4a47c] transition-colors duration-300">
                  <FaMapMarkerAlt className="text-[#c4a47c] group-hover:text-[#0f172a] text-base" />
                </div>
                <div className="min-w-0">
  <span className="block text-[#c4a47c] text-[10px] font-black uppercase tracking-widest mb-1">
    Address
  </span>
  <a 
    href={googleMapsUrl} 
    target="_blank" 
    rel="noopener noreferrer"
    className="group block"
  >
    <p className="text-white font-bold text-[14px] leading-tight transition-colors duration-300 group-hover:text-[#c4a47c]">
      Barbaros Blvd. Gurel Apt. No: 49/10 Fl: 6 <br className="hidden sm:block" />
      34022 Besiktas / Istanbul, TURKEY
    </p>
  </a>
</div>
              </div>

            </div>
          </div>
        </div>

    
        <div className="pt-10 border-t border-white/5 flex flex-col items-center space-y-4">
          <p className="text-slate-200 font-bold text-[13px] tracking-widest uppercase text-center opacity-80">
            © 2011 - 2026 Armar Shipping Company. All Rights Reserved.
          </p>
          <div className="flex items-center space-x-3 text-[11px] font-black uppercase tracking-[0.4em]">
            <span className="text-slate-200 italic">Digital Partner:</span>
            <a 
              href="https://www.junyazilim.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#c4a47c] hover:text-white transition-colors duration-300 underline underline-offset-4 decoration-[#c4a47c]/30"
            >
              Jun Yazılım
            </a>
          </div>
        </div>
      </div>

      
      {showScroll && (
        <button 
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 w-12 h-12 bg-[#c4a47c] text-[#0f172a] rounded-xl flex items-center justify-center shadow-2xl hover:scale-110 transition-all duration-500"
        >
          <FaArrowUp size={18} />
        </button>
      )}
    </footer>
  );
};

export default Footer;